"use client";

import React from "react";
import { ArrowRight, Scale, FileText, Building2, Handshake, Briefcase } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [];
export default function AssistanceTypes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="tipologie-di-assistenza" ref={ref} className="bg-background py-20 lg:py-32 relative overflow-hidden">
      {}
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className={cn("mb-16 text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
     <h2 className="text-foreground mb-6 tracking-tighter !font-sans text-2xl text-center w-full max-w-5xl mx-auto leading-[1.1] uppercase antialiased !font-normal md:mb-8 sm:text-4xl md:text-5xl lg:text-6xl md:text-left md:mx-0 md:pl-24">&nbsp; &nbsp; ATTIVITÀ GIUDIZIARIA</h2>


          <p className="text-muted-foreground text-lg max-w-2xl mx-auto leading-relaxed !text-justify">Lo Studio DCLegal, mediante il proprio Team di professionisti con esperienze e competenze diversificate e anche grazie all’ampia rete di collaborazioni con professionisti esterni specializzati in diversi settori del diritto, è in grado di fornire assistenza giudiziaria in materia civile, commerciale, tributaria, penale e amministrativa.</p>
        </div>

        <div className={cn("transition-all duration-1000 delay-200 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <Accordion type="single" collapsible className="w-full space-y-4">
            {services.map((service, index) => <AccordionItem key={service.id} value={service.id} data-index={index} className="border border-[var(--ring)]/30 rounded-lg px-6 bg-card/50 hover:bg-card/80 transition-colors duration-300 data-[state=open]:border-[var(--ring)] data-[state=open]:bg-card shadow-sm">
                <AccordionTrigger className="py-6 hover:no-underline group">
                  <div className="flex items-center gap-4 text-left">
                    <div className="p-2 rounded-full bg-secondary/50 text-primary group-hover:bg-[var(--ring)]/20 group-hover:text-[var(--ring)] transition-colors duration-300">
                      <service.icon className="w-5 h-5" />
                    </div>
                    <span className="text-xl text-foreground group-hover:text-primary/80 transition-colors !font-sans">
                      {service.title}
                    </span>
                  </div>
                </AccordionTrigger>
                
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}